import React, { useState } from 'react';
import { getUserDetails } from "../Utility/AsyncStorageData";
import Navbar from './Navbar';
import '../Styles/Complain.css'
import axios from "axios";
import Header from "./Header";

const ComplainBox = () => {

    let getDetails = getUserDetails()
    const [formData, setFormData] = useState("");
    const [submitted, setSubmitted] = useState(false);
      const [test, setTest] = React.useState(1);

    const navbarRender = (data) => {
    // console.log('Data received from child:', data);
    setTest(!test)
  };

    const handleChange = (e) => {
        setFormData(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Feedback submitted:', formData, getDetails);
        try {
            let url = process.env.REACT_APP_BASE_URL + "/api/insertComplaintLog";
            let body = {
                comp_num: getDetails.comp_num,
                user_num: getDetails.user_id,
                log: formData
            }

            console.log("feedback body", body)
            await axios.post(url, body, {
                headers: {
                    'authorization': `${getDetails.access_token}`
                },
            }).then(response => {

                if (response.status === 200) {

                    if (response.data.statusCode === 0) {
                        setSubmitted(true);
                    }

                    else {
                        console.log(" addUser error: ", response.data.msg);
                    }
                }

            }).catch(error => {
                console.log("error: ", error);
                return
            })
        } catch (error) {
            console.log("error ", error)
            throw error;
        }
    }

    return (
        <div className='main'>

            <div>
                <Navbar />
            </div>
            <div className='Admin_menu'>

                <Header show={1} sendNavbarToParent={navbarRender} />


                <div className="feedback-container">
                    {submitted ? (
                        <div className="thank-you">
                            <h2>🎉 Thank you!</h2>
                            <p>Your feedback has been received.</p>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="feedback-form">
                            <h2>📝 Feedback Form</h2>

                            <textarea
                                name="message"
                                placeholder="Your Feedback"
                                rows="5"
                                value={formData}
                                onChange={handleChange}
                                required
                            />

                            <button type="submit">Submit Feedback</button>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};


export default ComplainBox;
